module.exports = __webpack_public_path__ + "img/image.12a7f388.svg";